/* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable complexity */
(() => {
  const searchReset = () => {
    $(document).find('.ph-freetextsearch__data').html('');
    $(document).find('.ph-freetextsearch__titlecount').html('');
    ACC.freetextordersearch.resultCount = 0;
    $('.ph-freetextsearch__pagecount').attr('data-number-of-pages', '');
    $('.ph-freetextsearch__pagecount').attr('data-initiated', 0);
  };

  const colleaguesOrders = () => {
    const $checkbox = $('.ph-colleaguesOrders');

    if (sessionStorage.getItem('colleaguesOrders') === 'true' || window.location.href.indexOf('orderCode=') !== -1) {
      $checkbox.prop('checked', true);
      $('.ph-allOrders').removeClass('ph-d-none');
    } else {
      $checkbox.prop('checked', false);
      $('.ph-allOrders').addClass('ph-d-none');
    }
  };

  const showResult = () => {
    $(document).find('.ph-myOrders-data').addClass('ph-d-none');
    $(document).find('.ph-myApprovalOrders-data').addClass('ph-d-none');
    $(document).find('.ph-ordersControl .ph-filter').addClass('ph-d-none');
    $(document).find('.ph-freetextsearch__resultwrapper').removeClass('ph-d-none');
    $(document).find('.ph-freetextsearch__title').removeClass('ph-d-none');
  };

  const noResult = (textValue) => {
    ACC.freetextordersearch.$checkbox.closest('.ph-filter').addClass('ph-d-none');
    $(document).find('.ph-freetextsearch__title').addClass('ph-d-none');
    $(document).find('.ph-freetextsearch__noresulttext').text(`"${textValue}"`);
    $(document).find('.ph-freetextsearch__noresult').removeClass('ph-d-none');
  };

  const renderNonSparePartTemplate = (orderHeaderTemplate, orderData) => {
    let orderHeader = orderHeaderTemplate;
    const poNumberText = $('.ponumberlabel').text(),
        nullSporder = $('.ph-orderhistory__nullspsorderid').text();

    orderHeader = `${orderHeader} <div class="accordion-toggle ph-orderhistory_title ph-col-6 ph-col-md-4 ph-float-left" data-toggle="collapse"
                  data-parent="#accordion" aria-expanded="true" data-orderid=${orderData.code}>`;

    if (orderData.sapOrderId) {
      orderHeader = `${orderHeader}#${orderData.sapOrderId}`;

      if (ACC.freetextordersearch.isHhs === 'true') {
        orderHeader = `${orderHeader}(${orderData.code})`;
      }
    } else if (orderData.isSparePartOrder && orderData.sapOrderId === null) {
      orderHeader = `${orderHeader}#${nullSporder}`;
    } else {
      orderHeader = `${orderHeader}#${orderData.code}`;
    }

    orderHeader = `${orderHeader} </div>`;

    if (orderData.purchaseOrderNumber !== '') {
      orderHeader = `${orderHeader}
      <div class="ph-col-6 ph-col-md-3 ph-ponumber ph-float-left ph-d-flex">
      <span class="ph-ponumber-label">
      ${poNumberText}
      </span>
      <span title=${orderData.purchaseOrderNumber} class="ph-ponumber-value ph-text-truncate">
      ${orderData.purchaseOrderNumber} </span></div>`;
    }

    return orderHeader;
  };

  const renderTotalandPrice = (orderHeaderTemplate, orderData) => {
    const {statusDisplay} = orderData,
        isnonhybrisorder = $('.ph-isnonhybrisorder').html(),
        sortingDisplayText = $.trim($(`.ph-sortingtext_${orderData.statusDisplay}`).html());
    let orderHeader = orderHeaderTemplate,
        status = statusDisplay.charAt(0).toUpperCase() + statusDisplay.slice(1).toLowerCase();

    orderHeader = `${orderHeader} <div class="ph-col-12 ph-orderhistory_titleinfo ph-p-0 ph-float-left">
    <span class="ph-col-4 ph-pr-0 ph-float-left ph-orderhistory_fontstyle">
    ${orderData.stringDate} </span>
    <span class="ph-col-3 ph-pr-1 ph-orderhistory_tolprice ph-orderhistory_fontstyle ph-float-left">`;

    if (isnonhybrisorder === 'true' && isnonhybrisorder !== '') {
      orderHeader = `${orderHeader} <span> ${orderData.totalPrice.formattedValue} </span>`;
    }

    if (orderData.net === true) {
      orderHeader = `${orderHeader} <span> ${orderData.totalPriceWithTax.formattedValue} </span>`;
    } else {
      orderHeader = `${orderHeader} <span> ${orderData.totalPrice.formattedValue}</span>`;
    }

    orderHeader = `${orderHeader}</span>`;

    if (orderData.statusDisplay && sortingDisplayText !== '') {
      status = sortingDisplayText;
    }

    if (orderData.statusCode) {
      status = `${orderData.statusCode}`;
    }

    orderHeader = `${orderHeader} <span class="ph-col-4 ph-pr-0 ph-float-left ph-orderhistory-created">
    <span class="ph-orderhistory-dot ph-float-left ph-${orderData.statusDisplay.toUpperCase()}"></span>
    <p class="ph-orderhistory__status ph-orderhistory_fontstyle ph-mb-0">${status}</p>
    </span></div></div>`;

    return orderHeader;
  };

  const setAddress = (orderHeaderTemplate, addressTitleText, addressTypeObject) => {
    let orderHeader = orderHeaderTemplate;

    const addressTitle = addressTitleText,
        addressType = addressTypeObject;

    if (addressType) {
      orderHeader = `${orderHeader} <div class="ph-col-12 ph-float-left">
      <span class="strong"> ${addressTitle}</span>
      <div class=""><ul class="ph-mb-2">
      <li> ${addressType.companyName} </li>`;

      if (addressType.companyName2) {
        orderHeader = `${orderHeader} <li> ${addressType.companyName2} </li>`;
      }

      orderHeader = `${orderHeader} <li> ${addressType.line1} </li>`;

      if (addressType.europeanAddressFormat) {
        orderHeader = `${orderHeader}<li> ${addressType.postalCode}  ${addressType.town} </li>`;
      } else {
        orderHeader = `${orderHeader} <li>${addressType.town}, `;

        if (addressType.region && $('.showRegion').html() === 'true') {
          orderHeader = `${orderHeader} ${addressType.region.isocodeShort}  `;
        }

        orderHeader = `${orderHeader} ${addressType.postalCode} <li>`;
      }

      orderHeader = `${orderHeader} </ul></div></div>`;
    }

    return orderHeader;
  };

  const renderDeliveryMethod = (orderHeaderTemplate, orderData) => {
    let orderHeader = orderHeaderTemplate;
    const deliveryFreeText = $(document).find('.ph-text-deliverymethod').text(),
        deliveryFreePreviousText = $(document).find('.ph-text-deliverypreference').text(),
        shipFreeText = $(document).find('.ph-text-shiptonumber').text(),
        multiFreeText = $(document).find('.ph-text-multipleshipments').text();

    orderHeader = `${orderHeader} <div class="ph-col-12 ph-col-md-6 ph-p-sm-0 ph-float-left">`;

    if (orderData.deliveryMode) {
      orderHeader = `${orderHeader} <span class="strong"> ${deliveryFreeText} </span>;
     <p class="ph-order-delivery-details ph-mb-2">${orderData.deliveryMode.name}</p>`;

      if (orderData.isCompleteDelivery && orderData.isCompleteDelivery === true) {
        orderHeader = `${orderHeader} <span class="strong">
        ${deliveryFreePreviousText}
        </span>
        <p class="ph-order-delivery-details ph-mb-2">
        ${shipFreeText}</p>`;
      } else if (orderData.isCompleteDelivery && orderData.isCompleteDelivery === false) {
        orderHeader = `${orderHeader} <span class="strong"> ${deliveryFreePreviousText}
          </span><p class="ph-order-delivery-details ph-mb-2">
          ${multiFreeText}</p>`;
      }

      if (orderData.deliveryAddress) {
        orderHeader = `${orderHeader}
        <span class="strong"> ${shipFreeText}</span>
        <p class="ph-order-delivery-details ph-mb-2">
        ${orderData.deliveryAddress.customerNumber}</p>`;
      }

      orderHeader = `${orderHeader} </div>`;
    }

    return orderHeader;
  };

  const renderAddressHhs = (orderHeaderTemplate, orderData) => {
    let orderHeader = orderHeaderTemplate;

    orderHeader = `${orderHeader}
    <div class="ph-orderhistory_address ph-orderhistory_border ph-col-12 ph-p-0 ph-float-left">
    <div class="ph-col-12 ph-col-md-6 ph-p-0 ph-float-left">`;

    orderHeader = setAddress(orderHeader, $(document).find('.ph-text-shippingaddress').text(), orderData.deliveryAddress);

    orderHeader = `${orderHeader} </div>`;

    orderHeader = renderDeliveryMethod(orderHeader, orderData);

    orderHeader = `${orderHeader} </div>`;

    return orderHeader;
  };

  const renderAddressPcms = (orderHeaderTemplate, orderData) => {
    let orderHeader = orderHeaderTemplate;

    orderHeader = `${orderHeader} <div class="ph-orderhistory_address ph-orderhistory_border ph-col-12 ph-p-0 ph-float-left">
 <div class="ph-col-12 ph-col-md-6 ph-p-0 ph-float-left">`;

    orderHeader = setAddress(orderHeader, $(document).find('.ph-text-billingaddresses').text(), orderData.paymentAddress);
    orderHeader = setAddress(orderHeader, $(document).find('.ph-text-shippingaddress').text(), orderData.deliveryAddress);
    orderHeader = setAddress(orderHeader, $(document).find('.ph-text-payeeaddresses').text(), orderData.payerAddress);

    orderHeader = `${orderHeader} </div>`;

    orderHeader = `${orderHeader} </div>`;

    return orderHeader;
  };

  const renderPanelBodyTop = (orderHeaderTemplate, orderData) => {
    let orderHeader = orderHeaderTemplate;

    const contactNumberText = $(document).find('.ph-text-contactphonenumber').text(),
        paymentText = $(document).find('.ph-text-paymenttype').text();

    orderHeader = `${orderHeader} <div class="ph-orderhistory_details ph-orderhistory_border ph-mb-1 ph-col-12 ph-p-0 ph-float-left">`;

    if (orderData.deliveryPhone) {
      orderHeader = `${orderHeader} <div class="ph-col-12 ph-p-0 ph-float-left"><div class="ph-col-6 ph-float-left">
      <p class="strong"> ${contactNumberText}</p>
      </div><div class="ph-col-6 ph-p-0 ph-float-left">
     <p> ${orderData.deliveryPhone}</p></div></div>`;
    }

    if (orderData.paymentType) {
      orderHeader = `${orderHeader} <div class="ph-col-12 ph-p-0 ph-float-left"><div class="ph-col-6 ph-float-left"><p class="strong">
     ${paymentText}</p>
      </div><div class="ph-col-6 ph-float-left ph-p-0">
      <p>${orderData.paymentType.displayName}</p></div></div>`;
    }

    orderHeader = `${orderHeader} </div>`;

    if (ACC.freetextordersearch.isHhs === 'true') {
      orderHeader = renderAddressHhs(orderHeader, orderData);
      orderHeader = `${orderHeader}  <div class="ph-lazyloaded-invoices"></div>`;
    } else {
      orderHeader = renderAddressPcms(orderHeader, orderData);
      orderHeader = `${orderHeader} <div class="ph-lazyloaded-invoices ph-d-none"></div>`;
    }

    return orderHeader;
  };

  const orderTotal = (orderHeaderTemplate, orderData) => {
    let orderHeader = orderHeaderTemplate;
    const isnonhybrisorder = $('.ph-isnonhybrisorder').html(),
        totalText = $(document).find('.ph-text-total').text(),
        includesText = $(document).find('.ph-text-includestax').text(),
        adminFreeText = $(document).find('.ph-text-adminfee').text();

    orderHeader = `${orderHeader} <div class="ph-orderhistory_total ph-mt-1 ph-col-12 ph-p-0 ph-float-left">`;

    if (isnonhybrisorder === 'true' && isnonhybrisorder !== '') {
      orderHeader = `${orderHeader} <div class="ph-col-12 ph-float-left ph-orderhistory_totval">
      <span class="ph-float-left ph-total"> ${totalText}</span>
      <span  class="ph-float-right ph-font-weight-bold ph-total"> ${orderData.totalPrice.formattedValue} </span>
            </div>`;
    } else {
      if (orderData.net === true) {
        orderHeader = `${orderHeader}
              <div class="ph-col-12 ph-float-left ph-mb-1 ph-orderhistory_totval">
              <span class="ph-float-left ph-total"> ${totalText}</span>
              <span  class="ph-float-right ph-font-weight-bold ph-total">  ${orderData.totalPriceWithTax.formattedValue} </span>
              </div>`;
      } else {
        orderHeader = `${orderHeader} <div class="ph-col-12 ph-float-left ph-mb-1 ph-orderhistory_totval">
        <span class="ph-float-left ph-total"> ${totalText}</span>
        <span  class="ph-float-right ph-font-weight-bold ph-total"> ${orderData.totalPrice.formattedValue} </span>
              </div>`;
      }

      if (orderData.net === false) {
        orderHeader = `${orderHeader} <p> ${includesText}</p>`;
      }

      if (orderData.adminFee && orderData.adminFee !== '' && orderData.adminFee > 0) {
        orderHeader = `${orderHeader} <p>${adminFreeText}</p>`;
      }
    }

    orderHeader = `${orderHeader} </div>`;

    return orderHeader;
  };


  const productDetailsCondition = (orderHeaderTemplate, productEntryData) => {
    let orderHeader = orderHeaderTemplate;
    const backorderedText = $(document).find('.ph-text-backordered').text(),
        discontinuedText = $(document).find('.ph-text-hasbeendiscontinued').text(),
        notAvailableProduct = $(document).find('.ph-text-nolongeravailable').text();

    if (productEntryData.product.isLumifyWarranty !== '' &&
        (productEntryData.product.approval === 'approved' || productEntryData.product.approval === 'regulatoryonhold')) {
      orderHeader = `${orderHeader} href=${productEntryData.product.url}>`;
    }

    orderHeader = `${orderHeader} <p class="ph-orderhistory_productname ph-orderhistory_fontstyle ph-m-0 strong">${productEntryData.product.name}</p>
    <span class="ph-orderhistory_productCtn ph-orderhistory_productname ph-m-0">${productEntryData.product.ctn}</span>`;


    if ((productEntryData.product.code !== '') && productEntryData.product.code !== productEntryData.product.ctn) {
      orderHeader = `${orderHeader}<span>${productEntryData.product.code}</span>`;
    }

    if (productEntryData.isBackordered === true) {
      orderHeader = `${orderHeader} <p style="color:red">${backorderedText}</p>`;
    }

    if (productEntryData.product.approval === 'discontinued') {
      orderHeader = `${orderHeader} <p class="ph-m-0" style="color: red">${discontinuedText}</p>`;
    }

    if (productEntryData.product.approval !== 'approved' &&
    productEntryData.product.approval !== 'regulatoryonhold' &&
    productEntryData.product.approval !== 'discontinued') {
      orderHeader = `${orderHeader}<p class="ph-m-0" style="color: red">${notAvailableProduct}</p>`;
    }

    return orderHeader;
  };

  const productDetails = (orderHeaderTemplate, productEntryData) => {
    let orderHeader = orderHeaderTemplate;

    const estDeliveryText = $(document).find('.ph-text-estdelivery').text();

    orderHeader = `${orderHeader} <ul class="ph-m-0 ph-p-0">
    <li class="ph-orderhistory_productlist ph-float-left ph-p-0 ph-m-0 ph-col-12 ph-mt-1">
    <div class="ph-float-left ph-orderhistory_prodimg ph-col-3 ph-col-md-2 ph-col-lg-1 ph-p-0"><a`;

    if (productEntryData.product.isLumifyWarranty !== '') {
      if (productEntryData.product.approval === 'approved' || productEntryData.product.approval === 'regulatoryonhold') {
        orderHeader = `${orderHeader} href=>`;
      } else {
        orderHeader = `${orderHeader} >`;
      }
    }

    if (productEntryData.product.imageURL === null) {
      const noImage = `${ACC.config.commonResourcePath}/philipsUI/src/images/no-image-65x65.gif`;

      orderHeader = `${orderHeader} <div class="ph-p-0">
      <img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage ph-orderhistory__lazyimage" src=${noImage} class="thumb"/>
      </div>`;
    } else {
      orderHeader = `${orderHeader} <div class="ph-p-0">
      <img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage ph-orderhistory__lazyimage" 
      src=${productEntryData.product.imageURL} class="thumb"/>
      </div>`;
    }

    orderHeader = `${orderHeader}</a>
    </div>
    <div class="prod_info ph-float-left ph-col-9 ph-col-md-10 ph-col-lg-11 ph-p-0 ph-pl-2">
    <a class="ph-orderhistory_prodname ph-float-left ph-col-md-8 ph-col-sm-12 ph-p-0"`;

    orderHeader = productDetailsCondition(orderHeader, productEntryData);

    orderHeader = `${orderHeader}</a>
    <div class="ph-float-left ph-orderhistory_prodprice ph-orderhistory_fontstyle ph-orderhistory_productname ph-col-md-4 ph-col-sm-12 ph-p-0">
    <div class="ph-orderhistory_price ph-p-0">
    <p class="ph-m-0">${productEntryData.totalPrice.formattedValue}</p>
    </div></div></div>
    <div class="ph-col-12 ph-float-left ph-m-0 ph-p-0 ph-lazyloadestdate"
      id="lazyloadestdate ${productEntryData.orderCode}  ${productEntryData.entryNumber}"></div>`;


    if ((productEntryData.entryNumber === productEntryData.deliveryItemsQuantity) &&
        (productEntryData.orderCode === productEntryData.confirmationNumber) && productEntryData.estDelDate) {
      orderHeader = `${orderHeader} <div class="ph-loadestdate ph-col-12 ph-float-left ph-mt-1 ph-p-0 ph-orderhistory_productname">
      <span>${estDeliveryText}:</span>
      <span> ${productEntryData.estDelDate} </span></div>`;
    }

    orderHeader = `${orderHeader} </li></ul>`;

    return orderHeader;
  };

  const orderHistoryDetailsPart = (orderHeaderTemplate, productEntryData, trackingView) => {
    let orderHeader = orderHeaderTemplate;
    const toShippedText = $(document).find('.ph-text-tobeshipped').text();

    orderHeader = `${orderHeader} <div class="ph-orderhistory_tobeshippedproduct ph-col-12 ph-p-0 ph-float-left">`;

    if ($('.ph-ishhs').html() === 'true') {
      if (trackingView !== '') {
        orderHeader = `${orderHeader} ${trackingView}`;
      }

      orderHeader = `${orderHeader} <div data-productcode=${productEntryData.product.code} 
      class="ph-col-12 ph-float-left ph-p-0 ph-lazyload-deliveryitemlist"
      id="lazyloadpackinglist${productEntryData.orderCode}_${productEntryData.entryNumber}"></div>`;
    } else if (productEntryData.deliveryStatus === 'SHIPPED' || productEntryData.deliveryStatus === 'INVOICED') {
      orderHeader = `${orderHeader} <span class="ph-d-none shipmentcarriername">`;

      if (String(productEntryData.carrierName) !== 'null' && String(productEntryData.carrierName) !== '') {
        orderHeader = `${orderHeader} ${productEntryData.carrierName}`;
      }

      orderHeader = `${orderHeader} </span>
      <span class="ph-lazyload-tracking" id="lazyloadTracking ${productEntryData.product.code} ${productEntryData.entryNumber}"></span>`;
    }

    orderHeader = productDetails(orderHeader, productEntryData);

    if ($('.ph-ishhs').attr('data-to-beshipped') === 'true') {
      orderHeader = `${orderHeader} ${toShippedText}`;
    }

    orderHeader = `${orderHeader} </div>`;

    return orderHeader;
  };

  const productIterationPart = (orderHeaderTemplate, orderData) => {
    let orderHeader = orderHeaderTemplate,
        entriesorderdetails = '';
    const orderDetailsMapDataEntries = orderData.entries,
        trackingView = '';

    for (entriesorderdetails in orderDetailsMapDataEntries) {
      if (orderDetailsMapDataEntries !== '') {
        const productEntryData = orderDetailsMapDataEntries[entriesorderdetails];

        orderHeader = orderHistoryDetailsPart(orderHeader, productEntryData, trackingView);
      }
    }

    return orderHeader;
  };

  const renderButton = (orderHeaderTemplate, orderData) => {
    let orderHeader = orderHeaderTemplate;
    const veiwOrderText = $(document).find('.ph-text-viewfullorder').text();

    orderHeader = `${orderHeader} </div></div>
    <div class="ph-orderhistory_buttons ph-orderhistory_border ph-col-12 ph-float-left ph-pl-1">
    <a class="ph-order-viewall" target="_blank" href="${ACC.config.contextPath}/my-account/orders?orderCode=${orderData.code}#${orderData.code}">
     ${veiwOrderText}</a>
     </div></div>`;

    return orderHeader;
  };

  const renderPanelBody = (orderHeaderTemplate, orderData) => {
    let orderHeader = orderHeaderTemplate;

    orderHeader = `${orderHeader} <div class="ph-orderhistory_panelcollapse ph-collapse ph-in">
    <div class="ph-mediadiv ph-float-right ph-col-lg-2 ph-col-md-2 ph-col-sm-3">
    <button class="ph-printicon-image ph-print-myorder"></button>
        
        </div>
   <div class="ph-orderhistory__panelbody ph-p-0 ph-pt-1 ph-pb-1 ph-col-12 ph-float-left">`;
    orderHeader = renderPanelBodyTop(orderHeader, orderData);
    orderHeader = orderTotal(orderHeader, orderData);
    orderHeader = `${orderHeader} <div class="ph-orderhistory_products ph-col-12 ph-float-left">`;
    orderHeader = productIterationPart(orderHeader, orderData);
    orderHeader = renderButton(orderHeader, orderData);
    orderHeader = `${orderHeader} </div></div>`;

    return orderHeader;
  };

  const renderAccordion = (orderData) => {
    let orderHeader = '';

    if (orderData.user.uid === orderData.currentUser) {
      orderHeader = `<div class="ph-col-12 context-${orderData.code} ph-orderhistory__container  ph-mb-1 ph-float-left ph-p-0">`;
    } else {
      orderHeader = `<div class="ph-col-12 context-${orderData.code} ph-orderhistory__container ph-allOrders ph-mb-1 ph-float-left ph-p-0">`;
      $('.ph-freetextsearch__checkbox').closest('.ph-filter').removeClass('ph-d-none');
    }

    orderHeader = `${orderHeader} 
                  <div class="ph-orderhistory_panel ph-orderhistory_paneldefault">
                      <div class="ph-orderhistory_panelheading">
                        <div class="ph-orderhistory_paneltitle ph-icon-arrow-up ph-orderhistory_border ph-col-12 ph-float-left">`;
    orderHeader = renderNonSparePartTemplate(orderHeader, orderData);
    orderHeader = renderTotalandPrice(orderHeader, orderData);
    orderHeader = renderPanelBody(orderHeader, orderData);
    orderHeader = `${orderHeader} </div></div>`;

    $(document).find('.ph-freetextsearch__data').append(orderHeader);
  };

  const callAjax = (pageNumber) => {
    const textValue = $(document).find('.ph-freetextsearch__input').val();

    window.gaclkFn.orderHistorySearchOrder(textValue);

    $.ajax({
      type: 'GET',
      url: ACC.config.contextPath.concat('/orderSolrSearch/getSeachOrders.json'),
      dataType: 'json',
      data: {
        text: textValue,
        page: pageNumber
      },
      success: (result) => {
        showResult();
        $('.ph-freetextsearch__pagecount').attr(ACC.freetextordersearch.dataPages, result.numberPagesShown);

        if ($.isEmptyObject(result)) {
          noResult(textValue);
        } else {
          $(document).find('.ph-freetextsearch__noresult').addClass('ph-d-none');
          $.each(result, (key, orderData) => {
            if (key !== null && key !== 'numberPagesShown') {
              renderAccordion(orderData);
              ACC.freetextordersearch.markOrNot(key);
              ACC.freetextordersearch.resultCount = ACC.freetextordersearch.resultCount + 1;
            }
          });
        }

        $(document).find('.ph-freetextsearch__titlecount').text(`(${ACC.freetextordersearch.resultCount})`);
      },
      error: () => {
        noResult(textValue);
      }
    });
  };

  const loadOrders = (container, observer) => {
    const count = $('.ph-freetextsearch__data').find('.ph-orderhistory_panelheading').length / $('.ph-ordersshown').html(),
        numberOfPages = parseInt($('.ph-freetextsearch__pagecount').attr('data-number-of-pages'), 10),
        length = Math.ceil(count),
        initiated = parseInt($('.ph-freetextsearch__pagecount').attr('data-initiated'), 10);


    if ((initiated < length && length < numberOfPages) && (length <= numberOfPages)) {
      $('.ph-freetextsearch__pagecount').attr('data-initiated', length);
      $('.ph-load').show();
      callAjax(length);
    }

    if (length >= numberOfPages) {
      $('.ph-load').hide();
    }

    observer.unobserve(container);
  };

  const setObserver = () => {
    const container = document.querySelector('.ph-intersection-observer');

    const intersection = () => {
      const observer = new IntersectionObserver((entries) => {
        entries.map((entry) => {
          const {isIntersecting} = entry;

          if (isIntersecting) {
            loadOrders(container, observer);
            observer.observe(container);
          }

          /* eslint-disable array-func/no-unnecessary-this-arg */
          return true;
        }, {
          /* eslint-enable array-func/no-unnecessary-this-arg */
          root: null,
          rootMargin: '0px',
          threshold: 0
        });
      });

      observer.observe(container);
    };

    if ('IntersectionObserver' in window) {
      intersection();
    } else {
      fetch(`${ACC.config.commonResourcePath}/philipsUI/src/js/vendor/intersection-observer.min.js`, () => {
        intersection();
      });
    }
  };

  const bindAll = () => {
    $('.ph-orderhistory .ph-freetextsearch__input').keyup($.debounce(700, false, function() {
      searchReset();

      if ($(this).val() === '') {
        ACC.ordersLoader.hideSearchResult();
      } else {
        const pageNumber = 0;

        setTimeout(() => {
          setObserver();
        }, 1000);
        callAjax(pageNumber);
      }
    }));
    $('.ph-colleaguesOrders').on('change', function() {
      if ($(this).is(':checked')) {
        sessionStorage.setItem('colleaguesOrders', 'true');
      } else {
        sessionStorage.setItem('colleaguesOrders', 'false');
      }

      colleaguesOrders();
    });

    colleaguesOrders();
  };

  $(document).ready(() => {
    const tooltiptext = $(document).find('.ph-freetextsearch__tooltiptext');

    if ($(document).find('.ph-freetextsearch__wrapper').length > 0) {
      $(document).on('click', 'html, body', (event) => {
        if (!event.target.className.includes('ph-freetextsearch__tooltipicon') && !tooltiptext.hasClass('hidden')) {
          tooltiptext.addClass('hidden');
        }
      });
      bindAll();
    }

    $(document).on('click', '.ph-freetextsearch__tooltipicon', () => {
      tooltiptext.toggleClass('hidden');
    });

    if ((window.location.search.indexOf('orderCode') > 0) === true) {
      $('.ph-filter').addClass('ph-d-none');
    }
  });
})();
/* eslint-enable complexity */
/* eslint-enable max-statements */
/* eslint-enable max-lines */
